import React from 'react';

const SubServiceDetailSection2 = ({ data }) => {
    const {
        heading,
        p,
        backgroundColor = "bg-gray-50 dark:bg-zinc-800",
    } = data;


    return (
        <div className={`${backgroundColor} pt-25 text-center xl:text-left xl:px-35 px-10 pb-20 relative overflow-hidden flex items-center`}>
            {/* Dot Pattern Background */}
            {/* {dotPattern && <DotPattern />} */}

            <div className="w-full ">
                <div className="space-y-14 relative z-10 w-full">


                    {/* Main Heading */}
                    <div>
                        <h2 className="xl:text-5xl text-4xl font-bold text-black dark:text-white leading-tight">
                            {heading.split('\n').map((line, index) => (
                                <React.Fragment key={index}>
                                    {line}
                                    {index < heading.split('\n').length - 1 && <br />}
                                </React.Fragment>
                            ))}
                        </h2>
                    </div>

                    <div className='w-full text-xl leading-relaxed dark:text-white'>
                        {p}
                    </div>
                </div>


            </div>
        </div>
    );
};

export default SubServiceDetailSection2;
